const IOS_REGEX = /iphone|ipad|ipod/i;
const ANDROID_REGEX = /android/i;
const DISPLAY_MODE_QUERIES = [
  '(display-mode: standalone)',
  '(display-mode: minimal-ui)',
  '(display-mode: window-controls-overlay)',
  '(display-mode: fullscreen)',
];

function getNavigator() {
  if (typeof navigator === 'undefined') return undefined;
  return navigator;
}

function getWindow() {
  if (typeof window === 'undefined') return undefined;
  return window;
}

function detectIosPlatform(nav) {
  if (!nav) return false;
  const ua = nav.userAgent || '';
  const platform = nav.platform || '';
  const maxTouchPoints = typeof nav.maxTouchPoints === 'number' ? nav.maxTouchPoints : 0;

  if (IOS_REGEX.test(ua)) return true;

  // iPadOS reports itself as Mac, so fall back to platform + touch count.
  if (platform === 'MacIntel' && maxTouchPoints > 1) {
    return true;
  }

  return false;
}

export function getPlatform() {
  const nav = getNavigator();
  if (!nav) return 'web';

  const ua = nav.userAgent || '';
  const isIos = detectIosPlatform(nav);
  const isAndroid = ANDROID_REGEX.test(ua);

  if (isIos) return 'ios';
  if (isAndroid) return 'android';
  return 'web';
}

export function isStandaloneDisplayMode() {
  const win = getWindow();
  if (!win) return false;

  const nav = getNavigator();
  const isIosStandalone =
    typeof nav !== 'undefined' && typeof nav.standalone === 'boolean'
      ? nav.standalone
      : false;

  const matchesDisplayModeQuery = (query) => {
    if (!win || typeof win.matchMedia !== 'function') return false;
    try {
      return win.matchMedia(query).matches;
    } catch {
      return false;
    }
  };

  const hasStandaloneDisplayMode = DISPLAY_MODE_QUERIES.some((query) =>
    matchesDisplayModeQuery(query)
  );
  const hasWindowControlsOverlay =
    typeof nav?.windowControlsOverlay?.visible === 'boolean'
      ? nav.windowControlsOverlay.visible
      : false;

  return Boolean(
    isIosStandalone ||
      hasStandaloneDisplayMode ||
      hasWindowControlsOverlay
  );
}

export function getInstallContext() {
  const platform = getPlatform();
  const isInstalled = isStandaloneDisplayMode();
  return { platform, isInstalled };
}

export { DISPLAY_MODE_QUERIES };
